// extracted by mini-css-extract-plugin
export default {"btn":"AuthenticationDetails_btn__NWvLv"};